import PDFContext from "contexts/PDFContext";
import { IAnnotation } from "dto/IAnnotation";
import { useContext } from "react";

function useGetPDFViewer() {
  const { PDF, setPDF } = useContext(PDFContext);

  const zoom = () => {
    return PDF.zoom;
  };
  const page = () => {
    return PDF.page;
  };
  const getRotate = () => {
    return PDF.rotate;
  };
  const setRotate = (rotate: number) => setPDF({ ...PDF, rotate: rotate });
  const getShowAnnotation = () => {
    return PDF.showAnnotation;
  };
  const setShowAnnotation = (annotation: string | null) =>
    setPDF({ ...PDF, showAnnotation: annotation });
  const annotation = (): string | null => {
    return PDF.annotation;
  };
  const setAnnotation = (annotation: string | null) =>
    setPDF({ ...PDF, annotation: annotation });
  const getCanvas = () => {
    return PDF.canvas;
  };
  const getAnnotationToAdd = () => {
    return PDF.annotationToAdd;
  };
  const setAnnotationToAdd = (annotation: IAnnotation) =>
    setPDF({ ...PDF, annotationToAdd: annotation });
  const removeAnnotationToAdd = () => setPDF({ ...PDF, annotationToAdd: null });
  const getAnnotations = () => {
    return PDF.annotations;
  };
  const setAnnotations = (annotations: IAnnotation[]) => {
    return setPDF({ ...PDF, annotations: annotations });
  };
  const getDrawPin = () => {
    return PDF.drawPin;
  };
  const getDrawLine = () => {
    return PDF.drawLine;
  };

  const getDrawHighlight = () => {
    return PDF.drawHighlight;
  };

  const setDrawPin = (state: boolean) =>
    setPDF({ ...PDF, drawPin: state, drawLine: false, drawHighlight: false });
  const setDrawLine = (state: boolean) =>
    setPDF({ ...PDF, drawLine: state, drawPin: false, drawHighlight: false });

  const setDrawHighlight = (state: boolean) =>
    setPDF({ ...PDF, drawHighlight: state, drawPin: false, drawLine: false });

  return {
    getAnnotationToAdd,
    setAnnotations,
    getAnnotations,
    setAnnotationToAdd,
    removeAnnotationToAdd,
    page,
    zoom,
    annotation,
    setAnnotation,
    getShowAnnotation,
    setShowAnnotation,
    getCanvas,
    PDF,
    setPDF,
    getRotate,
    setRotate,
    getDrawPin,
    getDrawLine,
    setDrawPin,
    setDrawLine,
    setDrawHighlight,
    getDrawHighlight,
  };
}

export default useGetPDFViewer;
